import { AvailableTradesGraphBarSeries, AvailableTradesGraphLineSeries } from '@finance-lab/utils/types'

export const lineSeriesDropdownItems: Array<{ id: AvailableTradesGraphLineSeries }> = [
    { id: 'closePrice' },
    { id: 'vwap' },
    { id: 'marketcap' },
    { id: 'numberOfShares' },
] as const

export const lineSeriesLabelKeys: Record<AvailableTradesGraphLineSeries, string> = {
    closePrice: 'pages.companies.graph.closePrice',
    vwap: 'pages.companies.graph.vwap',
    marketcap: 'pages.companies.marketCap',
    numberOfShares: 'pages.companies.numberOfShares',
}

export const graphLineSerieRoutingParam = 'lineSerie' as const

export const barSeriesDropdownItems: Array<{ id: AvailableTradesGraphBarSeries }> = [
    { id: 'splitAdjustedQuantity' },
    { id: 'turnoverSek' },
    { id: 'tradedProportion' },
] as const

export const barSeriesLabelKeys: Record<AvailableTradesGraphBarSeries, string> = {
    splitAdjustedQuantity: 'pages.companies.numberOfShares',
    turnoverSek: 'pages.companies.graph.turnoverSek',
    tradedProportion: 'pages.companies.graph.tradedProportion',
}

export const graphBarSerieRoutingParam = 'barSerie' as const
